export default {
  phone: /^\+?375(25|29|33|44)\d{7}$/,
  email: /^[a-zA-Z0-9][a-zA-Z\-_0-9.]{1,}[a-zA-Z0-9]@[a-zA-Z][a-zA-Z\-_0-9]{1,}[a-zA-Z].[a-zA-Z]{2,11}$/,
  vin: /^[A-H,J-N,P,R-Z,0-9]{17}$/,
};
